<template>
    <a
        href="/deposit-insurance"
        target="_blank"
        :class="['deposit-insurance-banner', `deposit-insurance-banner--${theme}`]"
    >
        <InsuranceLogoSvg />
        <div>
            <h4 class="deposit-insurance-banner__title">
                Вклады застрахованы
            </h4>
            <p class="deposit-insurance-banner__description">
                ПАО КБ&nbsp;&laquo;Центр-инвест&raquo; включен в&nbsp;реестр
                банков-участников системы обязательного страхования вкладов
                9&nbsp;декабря 2004&nbsp;года.
            </p>
        </div>
    </a>
</template>

<script>
import {defineComponent} from 'vue';

import {DEPOSIT_INSURENCE_THEMES} from '@/core/constants/components/bannersProps';
import InsuranceLogoSvg from '@/assets/images/components/deposits/asv-logo.svg?inline';

export default defineComponent({
    name: 'DepositInsuranceBanner',
    components: {
        InsuranceLogoSvg,
    },
    props: {
        theme: {
            type: String,
            default: () => DEPOSIT_INSURENCE_THEMES.BLUE,
            validator: (value) => {
                return Object.values(DEPOSIT_INSURENCE_THEMES).includes(value);
            },
        },
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/banners/deposit-insurance-banner';
</style>
